import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import configService from '../services/configService';

function BetaAvailabilityModal({ 
  isOpen, 
  onClose, 
  email 
}) {
  const { logout } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  if (!isOpen) return null;

  const handleJoinWaitlist = async () => {
    setLoading(true);
    
    try {
      await configService.joinBetaWaitlist(email);

      setShowThankYou(true);
      setTimeout(async () => {
        setShowThankYou(false);
        onClose();
        await logout();
      }, 3000);
      
    } catch (error) {
      console.error('Failed to join beta waitlist:', error);
      // Wait a moment to ensure error is logged before logout
      setTimeout(async () => {
        onClose();
        await logout();
      }, 500);
    } finally {
      setLoading(false);
    }
  };

  if (showThankYou) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white p-8 rounded-2xl max-w-md w-full mx-4 shadow-xl text-center">
          <h2 className="text-2xl font-bold text-blue-600 mb-4">Thank You!</h2>
          <p className="text-gray-600">
            We'll notify you as soon as the beta opens up. You'll be among the first to try Remote Assistant!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-2xl max-w-md w-full mx-4 shadow-xl">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Beta Testing in Progress</h2>
        <p className="text-gray-600 mb-6">
          Remote Assistant is currently in private beta testing. We're working with a select group 
          of businesses to perfect the experience before our public launch.
        </p>
        <p className="text-gray-600 mb-6">
          Would you like to join the waitlist to be notified when we open up?
        </p>
        
        <div className="flex gap-3">
          <button 
            className="flex-1 px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-semibold transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
            onClick={handleJoinWaitlist}
            disabled={loading}
          >
            {loading ? 'Joining...' : 'Join Beta Waitlist'}
          </button>
          <button 
            className="flex-1 px-6 py-3 bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 rounded-xl font-semibold transition-colors"
            onClick={() => {
              // Small delay to ensure any pending operations complete
              setTimeout(async () => {
                onClose();
                await logout();
              }, 100);
            }}
            disabled={loading}
          >
            No Thanks
          </button>
        </div>
      </div>
    </div>
  );
}

export default BetaAvailabilityModal;